import script from "./PropertyDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyDetails.vue?vue&type=style&index=0&id=54ec15c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ec15c5"]])

export default __exports__